import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_URL: z.string().default('http://localhost:4000'),
  VITE_SENTRY_DSN_FE: z.string().optional(),
});

export const env = EnvSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_SENTRY_DSN_FE: import.meta.env.VITE_SENTRY_DSN_FE,
});
